import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage, FormattedNumber } from 'react-intl'
import Products from '../lib/products'
import Utils from '../lib/utils'
import { totalOrderSum, totalOrderDiscount, insuranceMandatoryPrice } from '../lib/standalonePurchase'

class CartStandalonePurchase extends Component {

  productLine(item, index) {
    const { ageCategory } = Products.find(p => p.id === item.passType)
    const { skus } = this.props
    const skuToUse = item.skuToUse || 'skuId'

    return (
      <Fragment key={index}>
        <tr>
          <td className="pt-3">
            <FormattedMessage id={`passTypes.${item.passType}`} />
            {ageCategory && (
              <>
                ,&nbsp;
                <FormattedMessage
                  id={`giftcards.${ageCategory}`}
                  defaultMessage={ageCategory}
                />
              </>
            )}
          </td>
          <td className="pt-3 text-right">
            <FormattedNumber 
              value={Utils.getSkuPrice(item.passType, skuToUse, skus)}
              minimumFractionDigits={2}
            />
            &nbsp;kr.
          </td>
        </tr>
        {/* {Utils.requiresInsurance(item.passType) && !Utils.useDailyInsurance(item.passType) && (
          this.insuranceRow(item)
        )} */}
      </Fragment>
    )
  }

  // insuranceRow(item) {
  //   const { skus } = this.props
  //   return (
  //     <tr className="text-sm">
  //       <td>
  //         <FormattedMessage
  //           id="giftcards.cart.insuranceYearlyMandatory"
  //           defaultMessage="Mandatory yearly insurance"
  //         />
  //       </td>
  //       <td className="text-right">
  //         <FormattedNumber
  //           minimumFractionDigits={2}
  //           value={insuranceMandatoryPrice(item, skus)}
  //         />
  //         &nbsp;kr.
  //       </td>
  //     </tr>
  //   )
  // }

  couponDiscountRow() {
    const { couponInfo } = this.props
    return (
      <tr>
        <td className="pt-3">
          { couponInfo.name }
          &nbsp;
          <strong>
            (-
            {couponInfo.percent_off}
            %)
          </strong>
        </td>
        <td className="pt-3 text-right">
          <FormattedNumber
            value={totalOrderDiscount() * -1}
            minimumFractionDigits={2}
          />
          &nbsp;kr.
        </td>
      </tr>
    )
  }
  
  render() {
    const { items, couponInfo, skus, discountCode } = this.props

    return (
      <div className="mt-4">
        <div className="flex bg-harbor">
          <h2 className="flex-grow text-aluminium m-0 p-6">
            <FormattedMessage
              id="giftcards.cart.header"
              defaultMessage="Your order"
            />
          </h2>
        </div>
        <div className="bg-aluminium px-8 py-6">
          <table className="w-full border-collapse">
            <thead>
              <tr className="text-sm">
                <th className="text-left pb-3 border-b border-grey">
                  <FormattedMessage
                    id="giftcards.cart.item"
                    defaultMessage="Item"
                  />
                </th>
                <th className="text-right pb-3 border-b border-grey">
                  <FormattedMessage
                    id="giftcards.cart.subTotal"
                    defaultMessage="Subtotal"
                  />
                </th>
              </tr>
            </thead>
            <tbody>
              {items
                ? items.map((item, index) => this.productLine(item, index))
                : null
              }
              { couponInfo && (
                this.couponDiscountRow()
              )}
            </tbody>
          </table>
        </div>
        <div className="flex bg-aluminium">
          <div className="rounded-full h-6 w-6 -ml-3 bg-white" />
          <div className="flex-grow bg-dotted-line h-6" />
          <div className="rounded-full h-6 w-6 -mr-3 bg-white" />
        </div>
        <div className="bg-aluminium px-8 py-6">
          <div className="flex items-baseline">
            <div className="flex-grow text-xl font-bold">
              <FormattedMessage
                id="giftcards.cart.grandTotal"
                defaultMessage="Grand total"
              />
            </div>
            <div className="text-2xl font-bold">
              <FormattedNumber
                minimumFractionDigits={2}
                value={totalOrderSum(items, skus, discountCode) - totalOrderDiscount(couponInfo, items, skus)}
              />
              &nbsp;kr.
            </div>
          </div>
        </div>
      </div>
    )
  }
}

CartStandalonePurchase.propTypes = {
  items: PropTypes.instanceOf(Array).isRequired,
  skus: PropTypes.instanceOf(Array).isRequired,
  // totalOrderDiscount: PropTypes.func.isRequired,
  couponInfo: PropTypes.shape({
    couponInfo: PropTypes.object
  }),
  discountCode: PropTypes.string
}

CartStandalonePurchase.defaultProps = {
  couponInfo: null,
  discountCode: null
}

export default CartStandalonePurchase;